import { createSlice } from "@reduxjs/toolkit"
import {
  cancelInterview,
  candidateAcceptPractical,
  candidateAcceptTheoretical,
  candidateInterviewReject,
  enableJobApplication,
  getAvailableSlots,
  getCandidatePracticalTrainingAvailable,
  getCandidateTheoreticalAvailable,
  getJobApplication,
  getJobApplicationDetails,
  getJobApplicationTimeline,
  interviewApply,
  resetJobApplication,
  verifyActionOtp,
  withdrawnJobApplication,
  getCandidateTrialOperations, candidateAcceptTrialOperation
} from "store/actions/jobApplicationAction"

const initialState = {
  loading: false,
  isLoading: false,
  jobApplication: [],
  jobApplicationDetails: {},
  availableSlots: [],
  timeLine: [],
  enabled_withdrawn_action: null,
  enabled_application_action: null,
  perPage: 50,
  totalPages: null,
  currentPage: null,
  totalCount: null,
  candidatesTheoreticalAvailable: [],
  candidatesPracticalAvailable: [],
  has_assessment_details: null,
  assessment_details: {},
  candidateTrialOperations: []
}

const usersSlice = createSlice({
  name: "job", //
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getJobApplication.pending, state => {
        state.loading = true
        state.totalPages = null
        state.totalCount = null
        state.currentPage = null
      })
      .addCase(getJobApplication.fulfilled, (state, action) => {
        state.loading = false
        const { success, data } = action.payload || {}
        if (success) {
          const { total_records, current_page, total_pages } =
            action.payload || {}
          state.jobApplication = data
          state.totalPages = total_pages
          state.totalCount = total_records
          state.currentPage = current_page
        }
      })
      .addCase(getJobApplication.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(getJobApplicationDetails.pending, state => {
        state.loading = true
        state.jobApplicationDetails = {}
      })
      .addCase(getJobApplicationDetails.fulfilled, (state, action) => {
        state.loading = false
        const { success, data } = action.payload || {}
        if (success) {
          state.jobApplicationDetails = data
        }
      })
      .addCase(getJobApplicationDetails.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(getAvailableSlots.pending, state => {
        state.loading = true
        state.jobApplicationDetails = {}
      })
      .addCase(getAvailableSlots.fulfilled, (state, action) => {
        state.loading = false
        const { success, data } = action.payload || {}
        if (success) {
          state.availableSlots = data
        }
      })
      .addCase(getAvailableSlots.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(interviewApply.pending, state => {
        state.isLoading = true
      })
      .addCase(interviewApply.fulfilled, (state, action) => {
        state.isLoading = false
        const { uuid } = action.meta.arg

        const { success, data } = action.payload || {}
        if (success) {
          //   state.availableSlots = state.availableSlots.filter(
          //     item => item.uuid !== uuid
          //   )
        }
      })
      .addCase(interviewApply.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(cancelInterview.pending, state => {
        state.isLoading = true
      })
      .addCase(cancelInterview.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(cancelInterview.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(withdrawnJobApplication.pending, state => {
        state.isLoading = true
      })
      .addCase(withdrawnJobApplication.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(withdrawnJobApplication.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(enableJobApplication.pending, state => {
        state.isLoading = true
      })
      .addCase(enableJobApplication.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(enableJobApplication.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(getJobApplicationTimeline.pending, state => {
        state.loading = true
      })
      .addCase(getJobApplicationTimeline.fulfilled, (state, action) => {
        state.loading = false
        const { success, data, application_actions } = action.payload
        if (success) {
          const { enabled_withdrawn_action, enabled_application_action } =
            application_actions || {}
          state.enabled_withdrawn_action = enabled_withdrawn_action
          state.enabled_application_action = enabled_application_action
          //   console.log(data)
          state.timeLine = data
        }
      })
      .addCase(getJobApplicationTimeline.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(verifyActionOtp.pending, state => {
        state.isLoading = true
      })
      .addCase(verifyActionOtp.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(verifyActionOtp.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(getCandidateTheoreticalAvailable.pending, state => {
        state.loading = true
        state.candidatesTheoreticalAvailable = []
        state.has_assessment_details = null
        state.assessment_details = {}
      })
      .addCase(getCandidateTheoreticalAvailable.fulfilled, (state, action) => {
        state.loading = false
        const { success, data, has_assessment_details, assessment_details } =
          action.payload || {}
        if (success) {
          state.candidatesTheoreticalAvailable = data
          state.has_assessment_details = has_assessment_details
          state.assessment_details = assessment_details
        }
      })
      .addCase(getCandidateTheoreticalAvailable.rejected, (state, action) => {
        state.loading = false
      })
    builder
      .addCase(getCandidatePracticalTrainingAvailable.pending, state => {
        state.loading = true
        state.candidatesPracticalAvailable = []
        state.has_assessment_details = null
        state.assessment_details = {}
      })
      .addCase(
        getCandidatePracticalTrainingAvailable.fulfilled,
        (state, action) => {
          state.loading = false
          const { success, data, has_assessment_details, assessment_details } =
            action.payload || {}
          if (success) {
            state.candidatesPracticalAvailable = data
            state.has_assessment_details = has_assessment_details
            state.assessment_details = assessment_details
          }
        }
      )
      .addCase(
        getCandidatePracticalTrainingAvailable.rejected,
        (state, action) => {
          state.loading = false
        }
      )

    builder
      .addCase(candidateAcceptTheoretical.pending, state => {
        state.isLoading = true
      })
      .addCase(candidateAcceptTheoretical.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(candidateAcceptTheoretical.rejected, (state, action) => {
        state.isLoading = false
      })
    builder
      .addCase(candidateAcceptPractical.pending, state => {
        state.isLoading = true
      })
      .addCase(candidateAcceptPractical.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(candidateAcceptPractical.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(candidateInterviewReject.pending, state => {
        state.isLoading = true
      })
      .addCase(candidateInterviewReject.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(candidateInterviewReject.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(resetJobApplication.pending, state => {
        state.isLoading = true
      })
      .addCase(resetJobApplication.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(resetJobApplication.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(getCandidateTrialOperations.pending, state => {
        state.loading = true
        state.candidateTrialOperations = []
      })
      .addCase(getCandidateTrialOperations.fulfilled,
        (state, action) => {
          state.loading = false
          const { success, data } = action.payload || {}
          if (success) {
            state.candidateTrialOperations = data
          }
        }
      )
      .addCase(getCandidateTrialOperations.rejected,
        (state, action) => {
          state.loading = false
        }
      )

    builder
      .addCase(candidateAcceptTrialOperation.pending, state => {
        state.isLoading = true
      })
      .addCase(candidateAcceptTrialOperation.fulfilled,
        (state, action) => {
        state.isLoading = false
      })
      .addCase(candidateAcceptTrialOperation.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default usersSlice.reducer
